export type INavbarLinks =
  | 'images'
  | 'possibilities'
  | 'rules'
  | 'comments'
  | 'location'
  | 'calendar'

type INavbarList = { title: string; link: INavbarLinks }

export const getNavbarList = (showCalendar = true): INavbarList[] => {
  const navbarList: INavbarList[] = [
    { title: 'تصاویر', link: 'images' },
    { title: 'مشخصات', link: 'possibilities' },
    { title: 'قوانین', link: 'rules' },
    { title: 'نظرات', link: 'comments' },
    { title: 'موقعیت', link: 'location' },
  ]

  if (showCalendar) {
    navbarList.push({ title: 'تقویم', link: 'calendar' })
  }

  return navbarList
}

export const houseTagsCarouselSetting = {
  perPage: 4,
  perMove: 1,
  direction: 'rtl',
  type: 'slide',
  gap: 8,
  drag: 'free',
  pagination: false,
  arrows: false,
  fixedWidth: '234px',
  breakpoints: {
    380: {
      perPage: 1,
      perMove: 1,
      arrows: false,
    },
    454: {
      perPage: 1,
      perMove: 1,
      arrows: false,
    },
    547: {
      perPage: 1,
      perMove: 1,
    },
    768: {
      perPage: 1,
      perMove: 1,
    },
    992: {
      perPage: 2,
      perMove: 1,
    },
    1288: {
      perPage: 3,
      perMove: 1,
    },
  },
}

export const similarHousesCarouselSetting = {
  perPage: 3,
  perMove: 1,
  direction: 'rtl',
  type: 'slide',
  gap: 0,
  drag: 'free',
  pagination: false,
  arrows: true,
  fixedWidth: '234px',
  breakpoints: {
    380: {
      perPage: 1,
      perMove: 1,
      arrows: false,
    },
    454: {
      perPage: 1,
      perMove: 1,
      arrows: false,
    },
    547: {
      perPage: 1,
      perMove: 1,
    },
    768: {
      perPage: 1,
      perMove: 1,
    },
    992: {
      perPage: 2,
      perMove: 1,
    },
    1288: {
      perPage: 3,
      perMove: 1,
    },
  },
}
